const $window = typeof window !== 'undefined' ? (window as any) : undefined
const SMARTLOOK_ID = process.env.SMARTLOOK_ID

if ($window && SMARTLOOK_ID) {
	const initScript = document.createElement('script')
	initScript.innerHTML = `window.smartlook||(function(d) {
    var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
    var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';
    c.charset='utf-8';c.src='https://web-sdk.smartlook.com/recorder.js';h.appendChild(c);
    })(document);
    smartlook('init', '${SMARTLOOK_ID}', { region: 'eu' });`
	document.head.appendChild(initScript)
}

export default {}
